<template>
<div class="rank-type">
    <Header />
    <div class="rank-banner" :style="{backgroundImage:'url('+rankObj.pcCoverImage+')'}">
        <div class="main-center-cont"><img :src="rankObj.pcCoverImage" alt=""></div>
    </div>
    <template v-for="item in rankings" >
        <RankCategoryItem :rankData="item" :key="item.id" />
    </template>
    <FooterSimple />

</div>
</template>
<script>
import RankCategoryItem from './rankCategoryItem.vue'
import Header from '@/common/header/header.vue'
import FooterSimple from '@/common/footer/footer-simple.vue'

export default {
    name:'InfoRankCategory',
    components:{RankCategoryItem,Header,FooterSimple},
    data(){
        return  {
            typeId:0,
            rankings:[],
            rankObj:{}
        }
    },
    created(){
        let typeId = parseInt(this.$route.params.type);
        console.log(typeId);
        this.typeId = typeId;
        this.getRankCategory();
    },
    methods:{
        async getRankCategory(){
            let result  = await this.$axios.post('/rankings/frontend/v1/get/rankings/list/by/type/id',{typeId:this.typeId});
            console.log(result);
            if( result.code == 0 ){
                this.rankings = result.data.rankings;
                this.rankObj = result.data.type;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.rank-type{background: #f8f8f8;}
.rank-banner{background-position: center top; background-repeat: no-repeat;}
.main-center-cont{width:720px; overflow: hidden; margin:0 auto;
    img{max-width: inherit; margin-left: 50%; transform: translateX(-50%);}
}
</style>
